import { Component, OnInit, Output, EventEmitter, ViewChild, Sanitizer, ElementRef, ChangeDetectorRef, Inject } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse, HttpParams } from '@angular/common/http';
import { request } from 'http';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
//import { RequestMetadata, PagedResult } from '../../../../lib/ng-crud-table';
import { MatTableDataSource, fadeInContent } from '@angular/material';
import { DataSource } from '@angular/cdk/table';
import { MatDialog, MatDialogConfig, PageEvent, MatPaginator } from '@angular/material';
import { Row } from 'lib/ng-data-table';
import { SelectItem, Keys } from 'lib/common';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { NgSwitchCase, DOCUMENT } from '@angular/common';
import { validateBasis } from '@angular/flex-layout';
import { SystemSettingConfig } from '../shared/models/SystemSettingConfig';
import { AppComponent } from '../app.component';
import { SystemSettingsService } from '../shared/services/system-settings/system-settings.service';
import { transcode } from 'buffer';
import { filter } from 'rxjs/operators';
import { CommonFilterService } from '../shared/services/common-filter/common-filter.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  rsltType: string = "login";

  title: string = "Login";
  staticScreen = true;
  @Output() childTitleEvent = new EventEmitter();

  baseUrl: string;
  url: string;
  showError: boolean = false;
  showErrorMsg: string = "";
  restrictPage: string = "5";
  keyword: any;
  adminName: any;
  isRebrandCompany: boolean = false;
  versionLabel: string = "6.4.20";
  loginType: string = "";

  localOrSession: boolean = false;
  loading: boolean = false;
  isLicenceChecked: boolean = false;

  loginCred = new SystemSettingConfig();
  sysSetting = new SystemSettingConfig();

  isCommonLogo: boolean = true;

  logserviceHTML: SystemSettingsService;
  //private parent: AppComponent, 
  constructor(private http: HttpClient, private logservice: SystemSettingsService, private commonFilterService: CommonFilterService, private cdr: ChangeDetectorRef, private dialog: MatDialog, @Inject(DOCUMENT) private _document: Document, private router: Router, private route: ActivatedRoute) {
    this.logserviceHTML = logservice;    
    this.baseUrl = environment.urlAddress + '/api/';
    this.ConfigSettings_Service();
    console.log(this.GetParam('k'))
    this.keyword = this.GetParam('k');//this.route.snapshot.queryParamMap.get('k');
    if (this.keyword != null) {
      //if (this.localOrSession) {
      //  localStorage.removeItem('Keyword');
      //  localStorage.clear();

      //  localStorage.setItem('Keyword', keyword1);
      //}
      //else {
      //  sessionStorage.removeItem('Keyword');
      //  sessionStorage.clear();

      //  sessionStorage.setItem('Keyword', keyword1);
      //}
      this.loginCred.UserName = "";
      this.KeywordLogin(this.keyword);
    }
    else
      this.LicenceCheck();

  }

  ngOnInit() {
    //this.GetSystemConfig();//NOT NEEDED
    ///// to do hard refresh after logout so that already selected filters/dates should be set to default
    let isLogout = this.route.snapshot.queryParamMap.get('logout');
    if (isLogout) {
      //console.log('logged out reload')
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        (window as any).location.reload();
      });
    }
  }

  GetParam(name) {
    const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
      return 0;
    }
    return results[1] || 0;
  }


  GetSystemConfig() {
    this.url = this.baseUrl + 'UserAndSytemConfig/GetUserSystemConfiguration';

    this.GetConfigurations_Service().subscribe((res: any) => {
      //debugger;
      let rows: any[] = JSON.parse(res) as any[];

      //this.sysSetting.AdminName = rows["AdminName"];
      //this.sysSetting.DBType = rows["DBType"];
      //this.sysSetting.DB_Name = rows["DB_Name"];
      //this.sysSetting.UserName = rows["UserName"];
      //this.sysSetting.Pin = rows["Pin"];
      //if (this.sysSetting.DBType != "1")
      //  this.sysSetting.Port = rows["Port"];
      ////this.sysSetting.DBPath = rows["DBPath"];
      ////this.sysSetting.ByPassPin = rows["ByPassPin"];
      //this.sysSetting.FailureCalls = rows["FailureCalls"];
      this.sysSetting.GoogleMapsAPIKey = rows["GoogleMapsAPIKey"];
      if (this.sysSetting.GoogleMapsAPIKey !== "")
        this.SaveConfiuration();
      ////this.sysSetting.SortEvents = rows["SortEvents"];
      ////this.sysSetting.CallTypeTerminating = rows["CallTypeTerminating"];
      ////this.sysSetting.OutPutGPSFormat = rows["OutPutGPSFormat"];
      ////this.sysSetting.OutPutTimestampFormat = rows["OutPutTimestampFormat"];
      ////this.sysSetting.SendConfigToScheduler = rows["SendConfigToScheduler"];
      //this.sysSetting.DB_IP = rows["DB_IP"];
      //this.sysSetting.LoginType = rows["LoginType"];

      //this.selectedDBTypes = [rows["DBType"]];
      ////this.selectedByPassPin = [rows["ByPassPin"]];
      ////this.selectedOutputTimestamp = [rows["OutPutTimestampFormat"]];
      ////this.selectedOutputGPS = [rows["OutPutGPSFormat"]];
      ////this.selectedConfigScheduler = [rows["SendConfigToScheduler"]];

    });
  }

  GetConfigurations_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }

  SaveConfiuration() {
    //debugger;

    //this.sysSetting.DBType = this.dbTypes.find(m => m.id == this.selectedDBTypes[0]).id;

    this.url = this.baseUrl + 'UserAndSytemConfig/SetMapsAPIKeyInHtml';
    this.SaveConfigurations_Service().subscribe((res: any) => {
      //console.log(res);
      if (res == "success") {
        //this.showErrorMsg = "saved successfully";
        //this.showError = true;
      }

    });
  }
  SaveConfigurations_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.sysSetting, options);

  }

  ///to check software licence
  async LicenceCheck() {
    this.isLicenceChecked = false;
    this.loading = true;
    this.logservice.UserName = "";//IMP IMP
    this.url = this.baseUrl + 'Login/LicenseCheck';
    //console.log('loginLic:' + new Date())
    return await this.GetLicData_Service().toPromise().then((res: any) => {
      //debugger
      this.isLicenceChecked = true;
      let rows: any = res;//JSON.parse(res) as any;
      //console.log(rows + 'loginLic:' + new Date())
      if (rows == "failed") {
        this.loading = false;
        this.logservice.UserName = "LicenseCheck";
        this.router.navigateByUrl('login/LicenseCheck');
      }
      else {
        this.parentEvent();

        //this.loginCred.UserName = "";
        //this.keyword = this.route.snapshot.queryParamMap.get('k');
        //console.log('login init')
        //if (this.keyword != null) {
        //  this.KeywordLogin(this.keyword);
        //}

        /// get LoginType
        this.isRebrandCompany = false;
        this.url = this.baseUrl + 'Login/GetLoginType';

        this.GetData_Service().subscribe((res: any) => {
          //debugger;
          let rows: any = res;//JSON.parse(res) as any;
          //console.log('loginTyped');
          if (rows != "" && rows != "Login failed") {
            this.isRebrandCompany = true;
            this.loginType = rows;
            this.logservice.LogType = rows;
            this.logservice.CompanyLogo = './assets/images/' + this.logservice.LogType + '/' + this.logservice.LogType + '_logo.png';
            this.logservice.CompanyRebrand = './assets/images/Rebrand/Rebrand.png';
          }
          else {
            this.isRebrandCompany = false;
          }
          this.loading = false;
        });
      }
    },
      error => {
        //console.log(error);
        this.loading = false;
      });
  }

  CheckValidation() {
    this.showError = false;
    this.showErrorMsg = "";

    if (this.loginCred.UserName == "" || this.loginCred.Pin == "") {
      this.showError = true;
      this.showErrorMsg = "Username and Pin cannot be empty";
      return false;
    }
    return true;
  }

  Login() {
    this.loading = true;
    if (!this.CheckValidation()) {
      this.loading = false;
      return;
    }
    //localStorage.setItem('ConfigScreen', null);
    localStorage.removeItem('ConfigScreen');
    this.showError = false;
    this.url = this.baseUrl + 'Login/LoginCheck';
    //debugger;
    this.LoginData_Service().subscribe((res: any) => {
      //debugger;
      this.loading = false;
      let rows: any = res;//JSON.parse(res) as any;
      //console.log(rows)
      if (rows == "wrong credentials") {
        this.showError = true;
        this.showErrorMsg = rows;
      }
      else if (rows == "Login failed") {
        this.showError = true;
        this.showErrorMsg = rows;
      }
      else {
        let UserName = (rows == "" || rows == "ADMIN_INCOMPLETEDATA") ? 'admin' : rows.UserName;
        this.logservice.UserName = UserName;
        this.logservice.isLoggedIn = true;
        if (this.logservice.LogType != "") {
          this.logservice.isCommonLogo = false;
          this.isCommonLogo = false;
        }

        let currRoute = 'dashboard/pesq';
        if (rows != "" && rows != "ADMIN_INCOMPLETEDATA") {
          //this.logservice.pageRefMessage(rows.Screens);
          //this.parent.RestrictScreenAfterLogin(rows.Screens);
          this.logservice.Criteria = rows.Criteria;
          this.logservice.restrictScreens = rows.Screens;
          this.logservice.authorizeFilters = rows.StartUp.split('|').length == 4 ? rows.StartUp.split('|')[3] : "";
          ////////// check if user previlege configed any mainfilter or not
          if (!rows.StartUp.includes('ALLON') && rows.StartUp.split('|').length == 4)
            this.logservice.mainFilterIDs = rows.StartUp.split('|')[2];///ALLON
          if (rows.StartUp.split('|')[2] == '')
            this.logservice.ismainFilterEnabled = false;
          else
            this.logservice.mainFilterIDs = rows.StartUp.split('|')[2];///if mainfilter is selected and 

          debugger;
          ////// to show/hide ModifyFilter in action control in dt-toolbar
          if (rows.StartUp.split('|')[2] != "undefined" && rows.StartUp.split('|')[2].length > 0) {
            this.commonFilterService.setIsFilters(false);
          }
          else
            this.commonFilterService.setIsFilters(true);


          this.SetStartUpScreen(rows.StartUp.split('|')[0]);
          currRoute = this.logservice.startupScreen.substring(1, this.logservice.startupScreen.length);
        }
        else {
          this.logservice.restrictScreens = "";
          this.logservice.Criteria = "";
          this.logservice.authorizeFilters = "";
          this.logservice.mainFilterIDs = "";
          this.logservice.ismainFilterEnabled = true;
        }

        //https://stackoverflow.com/questions/19867599/what-is-the-difference-between-localstorage-sessionstorage-session-and-cookies
        //https://www.c-sharpcorner.com/article/angular-7-login-with-session-authentication-using-the-reactive-form/
        if (this.localOrSession)
          localStorage.setItem('SystemSettings', JSON.stringify(this.logservice));
        else
          sessionStorage.setItem('SystemSettings', JSON.stringify(this.logservice));
        //debugger;


        ////testin purpose        
        if (rows == "ADMIN_INCOMPLETEDATA") {
          //alert("To enhance the security of your account, please ensure to provide a valid email address and (WebViewer IP or Domain Name) information in the Admin and System Settings page.");
          alert("  Alert!! \n  Make your account secure by adding the right email and \n  WebViewer info in settings.");
          //this.router.navigate(
          //  [
          //    //{ outlets: { filterPopup: null, configPopup: 'configuration/UserSetting/false/true' } }
          //    { outlets: { filterPopup: null, configPopup: ['configuration', 'UserSetting', false, 'true'] } }
          //  ],

          //);
          this.router.navigateByUrl(currRoute + '(configPopup:configuration/UserSetting/0/true)');
          return;
        }

        this.router.navigateByUrl(currRoute);
      }
    });
  }

  async KeywordLogin(keyword) {
    await this.LicenceCheck().then(() => {

      this.loading = true;
      this.showError = false;
      this.loginCred.LinkKeyword = keyword; ///for keywordlogin
      this.url = this.baseUrl + 'Login/KeywordLoginCheck';
      //debugger;
      this.LoginData_Service().subscribe((res: any) => {
        this.loading = false;
        //debugger;
        this.logservice.restrictScreens = "";
        this.logservice.Criteria = "";
        let rows: any = res;//JSON.parse(res) as any;
        if (rows == "wrong credentials") {
          this.showError = true;
          this.showErrorMsg = rows;
        }
        else {
          let UserName = rows == "" ? 'admin' : rows.UserName;
          this.logservice.isLoggedIn = true;
          this.logservice.UserName = UserName;
          if (this.logservice.LogType != "") {
            this.logservice.isCommonLogo = false;
            this.isCommonLogo = false;
          }

          //this.logservice.pageRefMessage(rows.Screens);
          //this.parent.RestrictScreenAfterLogin(rows.Screens);
          this.logservice.Criteria = rows.Criteria;
          this.logservice.restrictScreens = rows.Screens;
          this.logservice.authorizeFilters = rows.StartUp.split('|').length == 4 ? rows.StartUp.split('|')[3] : "";
          this.SetStartUpScreen(rows.StartUp.split('|')[0]);
          let currRoute = this.logservice.startupScreen.substring(1, this.logservice.startupScreen.length);

          if (this.localOrSession) {
            //console.log('keyset')
            localStorage.setItem('Keyword', keyword);
            localStorage.setItem('SystemSettings', JSON.stringify(this.logservice));
          }
          else {
            sessionStorage.setItem('Keyword', keyword);
            sessionStorage.setItem('SystemSettings', JSON.stringify(this.logservice));
          }
          this.router.navigateByUrl(currRoute);
        }
      });

    });
  }



  ForgotPassword() {

    this.router.navigateByUrl('forgotpassword');
    //this.router.navigateByUrl('login/Config');

  }

  Config() {

    //localStorage.setItem('ConfigScreen', null);
    this.loading = true;
    localStorage.removeItem('ConfigScreen');
    this.showError = false;
    this.url = this.baseUrl + 'Login/LoginCheck';

    //debugger;
    this.LoginData_Service().subscribe((res: any) => {
      //debugger;
      this.loading = false;
      let rows: any = res;//JSON.parse(res) as any;
      //console.log(rows)
      if (rows == "wrong credentials" || rows == "Login failed") {
        this.showError = true;
        this.showErrorMsg = rows;
      }
      else {

        //let queryUrl = 'login/Config?log=' + this.loginCred.UserName + '@' + this.loginCred.Pin;
        let queryUrl = 'login/Config';   //'login/Config';
        this.logservice.logDetail = this.loginCred.UserName + '@' + this.loginCred.Pin;
        //debugger;
        localStorage.setItem('ConfigScreen', 'true');
        this.router.navigateByUrl(queryUrl);
      }
    });


  }

  redirectTo(uri: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }


  SetStartUpScreen(startup) {
    //debugger;
    switch (startup) {
      case "vp":
        //Session["Menuname"] = "VQT PESQ";
        //RsltType.Value = "VQTPESQ";
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "vpol":

        //Session["Menuname"] = "VQT POLQA";
        //RsltType.Value = "VQTPOLQA";
        this.logservice.startupScreen = '/dashboard/polqa';
        break;
      case "vba":

        //Session["Menuname"] = "VBA (With or without E-Model)";
        //RsltType.Value = "VBADATA";
        this.logservice.startupScreen = '/dashboard/vba';
        break;
      case "emu":
        //Session["Menuname"] = "EMU Results";
        //RsltType.Value = "EMUDATA";
        this.logservice.startupScreen = '/dashboard/emu';
        break;
      case "vac":
        //Session["Menuname"] = "VAC Results";
        //RsltType.Value = "VACDATA";
        this.logservice.startupScreen = '/dashboard/vac';
        break;
      case "tcp":
      case "NetTestHead":
        //Session["Menuname"] = "Net Test Results";
        this.logservice.startupScreen = '/dashboard/nettest';
        break;
      case "MobileHead":
        //Session["Menuname"] = "Mobile Device Information";
        break;
      case "fax":
        //Session["Menuname"] = "FAX Results";
        //RsltType.Value = "FAXDATA";
        this.logservice.startupScreen = '/dashboard/fax';
        break;
      case "tdm":
        //Session["Menuname"] = "Audio and Delay Analysis";
        //RsltType.Value = "AUDIODELAY";
        this.logservice.startupScreen = '/dashboard/audio-delay';
        break;
      case "gd_Call":
      case "gd_Analysis":
      case "gd_NetTest":
        break;
      case "ud":
        break;
      case "cc":
        //Session["Menuname"] = "VQuad Call Events";
        //RsltType.Value = "VQUADDATA";
        this.logservice.startupScreen = '/dashboard/call-events';
        break;
      case "STATS_CALLEVENT":
        //Session["Menuname"] = "Call Events Statistics";
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "STATS_QOS":
        //Session["Menuname"] = "Audio and Delay Statistics";
        this.logservice.startupScreen = '/statistics/AudioDelayStatsPieChart';
        break;
      case "STATS_MEASUREMENT":
        //Session["Menuname"] = "VQT (PESQ) Measurements";
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "STATS_COMPLETEDCALL":
        //Session["Menuname"] = "Customized Stats";
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "STATS_NETWORKSTATUS":
        //Session["Menuname"] = "VQuad Probe Status";
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "STATS_SCHEDULERSTATUS":
        //Session["Menuname"] = "Scheduler Status";
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "sc"://Filters
      case "cs":
        return;
      case "SAVETOCSV":
      case "SAVETOPDF":
      case "SAVETOEXCEL":
      case "SAVEGPSFILE":
        break;
      case "CUSTOMREPORTS":
      case "WebviewerCRHead":
        //Session["Menuname"] = "Custom Reports";
        this.logservice.startupScreen = '/outputresult/CustomReport';
        break;
      case "DataImportCRHead":
        //Session["Menuname"] = "Custom Reports";
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "GMAPS":
      case "btnGoogleMapsRedirect":
        //Session["Menuname"] = "Latitude-Longitude Plot";
        this.logservice.startupScreen = '/outputresult/GoogleMap';
        return;
      case "VQuad":
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "AutoRemote":
        //Session["GridViewType"] = GRIDVIEW_TYPE.GD_AUTOVQUADREMOTE;
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "Configuration":
        //Session["GridViewType"] = GRIDVIEW_TYPE.GD_WEBCONFIGTOOL;
        this.logservice.startupScreen = '/dashboard/pesq';
        break;
      case "btnConsoleView":
        //Session["SelectdMenu"] = "VQuad";
        this.logservice.startupScreen = '/configuration/ConsoleViewConfig';
        break
      default:
        this.logservice.startupScreen = '/dashboard/pesq';
        break;

    }

  }


  ///////////////////////////////////////////////////////// SERVICES
  GetLicData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }
  GetData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, options);

  }
  LoginData_Service() {

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    return this.http.post<any>(this.url, this.loginCred, options);

  }
  ConfigSettings_Service() {
    this.url = this.baseUrl + 'Login/AddConfigSettings';

    var headerOptions = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = {
      headers: headerOptions
    };

    this.http.post(this.url, options).subscribe();
  }

  parentEvent() {
    this.childTitleEvent.emit({ title: this.title, staticScreen: this.staticScreen });
  }

  //eyeIconVisible = false;
  type = 'password';
  onEyeClick() {
    //this.eyeIconVisible = true;
    //console.log(this.type)
    if (this.type === "password") {
      this.type = "text";
    }
    else {
      this.type = "password";
    }
  }
}
